import { useContext } from 'react';

import CompareContext from './compare.context';

function useCompare() {
  const context = useContext(CompareContext);

  if (!context) {
    throw new Error('useCompare must be used within CompareContext');
  }

  return context;
}

export default useCompare;